// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1TxpV","productName":"Table_productName__KfEPy"};